import React from "react";
import { Box } from "@mui/material";
import type { CalloutSource } from "../../models/API";

interface SourceBadgeProps {
  source: CalloutSource;
}

/**
 * Small chip showing whether a callout is AI-generated or manually authored.
 * Replaces the hard-coded "Manual" chip from the previous ManualCalloutCard.
 *
 * Styled to match the existing impact-badge / status-badge dimensions in the
 * AI HTML so AI and manual cards line up visually.
 */
const SourceBadge: React.FC<SourceBadgeProps> = ({ source }) => {
  const isAi = source === "ai";
  const label = isAi ? "AI" : "Manual";
  const bg = isAi ? "#E3F2FD" : "#FFF3E0";
  const fg = isAi ? "#1565C0" : "#E65100";

  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        fontSize: "10px",
        fontWeight: "bold",
        textTransform: "uppercase",
        letterSpacing: "0.5px",
        padding: "3px 8px",
        borderRadius: "20px",
        bgcolor: bg,
        color: fg,
        flexShrink: 0,
      }}
    >
      {label}
    </Box>
  );
};

export default SourceBadge;
